import { render, staticRenderFns } from "./EventAttendanceDetails.vue?vue&type=template&id=95c34332&scoped=true&"
import script from "./EventAttendanceDetails.vue?vue&type=script&lang=js&"
export * from "./EventAttendanceDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventAttendanceDetails.vue?vue&type=style&index=0&id=95c34332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c34332",
  null
  
)

export default component.exports